import React from 'react'
import { Form, Formik } from 'formik'
import Button from '../../../components/common/Button'
import Input from '../../../components/common/Input'
import { required } from '../../../utils/validators'

export default function MarketForm({ onCancel, onSubmit, initialValues, loading }) {
    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={{
                name: '',
                square: '',
                directorName: '',
                phone: '',
                address: '',
                price: '',
                ...initialValues,
            }}
        >
            <Form>
                <Input name="name" label="Дўкон номи" placeholder="Дўкон номини киритинг" validate={required} />
                <Input name="square" label="Дўкон майдони" placeholder="Дўкон майдонини киритинг" validate={required} />
                <Input name="directorName" label="Директор номи" placeholder="Директор номини киритинг" validate={required} />
                <Input name="phone" label="Телефон номер" placeholder="Телефон номерини киритинг" validate={required} />
                <Input name="address" label="Манзил" placeholder="Манзилни киритинг" validate={required} />

                <Input name="price" label="Ижара суммаси" placeholder="Ижара суммасини киритинг" validate={required} />

                <div style={{ gap: 5 }} className="buttons is-flex is-justify-content-space-between mt-4">
                    <div className="button-wrapper">
                        <Button onClick={onCancel} icon="close-outline" text="Ёпиш" className="is-danger" />
                    </div>
                    <div className="button-wrapper">
                        <Button loading={loading} text="Сақлаш" icon="add-outline" type="submit" className="is-success" />
                    </div>
                </div>
            </Form>
        </Formik>
    )
}
